
<template>
    <div>
        <van-nav-bar    title="定位"  left-text="返回" @click-left="back"    left-arrow>
            <van-icon name="success" slot="right" size='20' @click="savePoint"/>
        </van-nav-bar>
        <van-search placeholder="查找地点" background='#fff' v-model="searchName" readonly  @click="searchPop" style='position:relative;z-index:99;top:50px;'/>
        <div id="gdMap_position" ref='amap'></div>        

        <van-popup  v-model="searchPopShow"    position="bottom"  :style="{ height: '100%' }">
            <div style="display:flex; justify-content: flex-start;align-items:center">
                <van-icon @click="searchPopShow = false;searchName=''" name="arrow-left" size='24px' style="padding:0 10px"/>
                <van-search  placeholder="查找地点" v-model="searchName"  @input='searchPoint'  style="width:100%"/>
            </div>

            <div style="position:absolute;top:50px;left:0;right:0;bottom:0;padding:10px;overflow:auto">
                <van-cell icon="location-o" @click="addMarker(item)" v-for="(item,index) in pointList" :key="index" :title="item.name" :label="item.district+item.address"  />
                <van-divider :style="{ padding: '0 16px' }">
                    没有更多了
                </van-divider>
            </div>
        </van-popup>

        
    </div>
</template>
<script>
var map
import {mapState,mapMutations} from 'vuex'
export default {
    name:'position',
    data() {
        return {
            clientHeight:'',
            searchName:'',
            searchPopShow:false,            
            pointList:[],
            temporary:{
                lat:'',
                lon:'',
                address:''
            },            
        }
    },
    computed: {
         ...mapState(['phonePosition'])
    },
    watch: {
        clientHeight: function () {
            this.changeFixed(this.clientHeight)
        }
    },
    mounted() {
        let _that = this
        this.clientHeight =   `${document.documentElement.clientHeight}`
        window.onresize = function temp() {
            this.clientHeight = `${document.documentElement.clientHeight}`;
        };

        map = new AMap.Map('gdMap_position', {
            resizeEnable: true,
            center: [this.phonePosition.lon,this.phonePosition.lat],
            zoom: 15
        });
        //地图点击事件
        map.on('click', _that.clickMap);

        let marker = new AMap.Marker({
            position: map.getCenter(),
            // icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
            // offset: new AMap.Pixel(-13, -30)
        });
        marker.setMap(map);

        this.temporary.lat = this.phonePosition.lat
        this.temporary.lon = this.phonePosition.lon
        this.temporary.address = this.phonePosition.address
    },    
    methods: {
        ...mapMutations(['setPhonePosition']),
        clickMap(e){
            // console.log(e.lnglat.lng,e.lnglat.lat)
            let _that = this
            let lnglat = [e.lnglat.lng,e.lnglat.lat]
            let geocoder = new AMap.Geocoder();
            geocoder.getAddress(lnglat, function(status, result) {
                if (status === 'complete'&&result.regeocode) {
                    map.clearMap();
                    let address = result.regeocode.formattedAddress;
                    let marker = new AMap.Marker({
                        position: new AMap.LngLat(lnglat[0], lnglat[1]),               
                    })
                    map.setCenter(lnglat);
                    marker.setMap(map);                    
                    _that.temporary.lon = lnglat[0]
                    _that.temporary.lat = lnglat[1]
                    _that.temporary.address = address
                }else{
                    console.log('根据经纬度查询地址失败')
                }
            })
        },
        searchPop(){
            this.searchPopShow = true
            this.pointList = []
            this.searchName = ''
        },
        searchPoint(value){
            if (value == '') {
                this.pointList = []
            }else{
                this.startSearch()
            }
        },
        startSearch(){
            let _that = this
            AMap.plugin('AMap.Autocomplete', function(){
                // 实例化Autocomplete
                let autoOptions = {
                city: '全国'
                }
                let autoComplete = new AMap.Autocomplete(autoOptions);
                autoComplete.search(_that.searchName, function(status, result) {
                // 搜索成功时，result即是对应的匹配数据                    
                    if (status=='no_data') {
                        _that.pointList = []
                    }else{                        
                         _that.pointList = result.tips
                    }
                })
            })
        },
        addMarker(item){
            map.clearMap();            
            let marker = new AMap.Marker({
                position: new AMap.LngLat(item.location.lng, item.location.lat),               
            });
            this.temporary.lon = item.location.lng
            this.temporary.lat = item.location.lat
            this.temporary.address = item.district+item.name
            map.setCenter([item.location.lng, item.location.lat]);
            marker.setMap(map);
            this.searchPopShow = false

        },
        savePoint(){
            let data = {}
            data.lat = this.temporary.lat
            data.lon = this.temporary.lon
            data.address = this.temporary.address
            this.setPhonePosition(data)
            this.$router.back(-1)

        },
        changeFixed(clientHeight){//动态修改地图高度样式
            this.$nextTick(() => {
                this.$refs.amap.style.height = (clientHeight-50)+'px';
            })
        },
        back(){
            this.$router.back(-1)
        }
    },
}
</script>

<style  scoped>
#gdMap_position{width:100%;height:700px}
.van-popup--bottom.van-popup--round{border-radius:10px 10px 0 0}
.van-search{background:rgba(0,0,0,0)!important}
.van-search__content{background:#fff!important}
</style>